import React from "react";
import {
  colorTokens,
  getShadow,
  getSpacing,
  getTypography,
} from "../../../designTokens";
import { isInFlightExportStatus } from "../../../utils/exportProgressStorage";
import type { TrackedExportJob } from "../../../utils/exportProgressStorage";

interface ExportMinimizedTileProps {
  job: TrackedExportJob;
  onExpand: () => void;
}

export const ExportMinimizedTile: React.FC<ExportMinimizedTileProps> = ({
  job,
  onExpand,
}) => {
  const inFlight = isInFlightExportStatus(job.status);
  const label = inFlight
    ? `Your ${job.entityLabel} export is in progress`
    : job.status === "FAILED"
      ? `Your ${job.entityLabel} export failed`
      : `Your ${job.entityLabel} export is ready`;

  return (
    <button
      type="button"
      onClick={onExpand}
      id={`export-progress-tile-${job.exportId}`}
      aria-label={`Restore export progress: ${label}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: getSpacing("12px"),
        minWidth: "280px",
        maxWidth: "420px",
        padding: `${getSpacing("12px")} ${getSpacing("16px")}`,
        border: `1px solid ${colorTokens["Borders/Light"]}`,
        borderRadius: getSpacing("12px"),
        backgroundColor: colorTokens["Background/White"],
        boxShadow: getShadow("Shadow"),
        cursor: "pointer",
        color: colorTokens["Text/Black"],
        textAlign: "left",
      }}
    >
      {inFlight ? (
        <span
          style={{
            width: "18px",
            height: "18px",
            flexShrink: 0,
            border: `2px solid ${colorTokens["Borders/Light"]}`,
            borderTopColor: colorTokens["Primary/Default"],
            borderRadius: "50%",
            animation: "export-spin 0.8s linear infinite",
          }}
          aria-hidden="true"
        />
      ) : (
        <span
          style={{
            width: "8px",
            height: "8px",
            flexShrink: 0,
            borderRadius: "50%",
            backgroundColor:
              job.status === "FAILED"
                ? colorTokens["Alert/Red/Dark"]
                : colorTokens["Primary/Default"],
          }}
          aria-hidden="true"
        />
      )}
      <span
        style={{
          ...getTypography("Body/Medium"),
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
      <span
        style={{
          ...getTypography("Links/Btn Text"),
          color: colorTokens["Primary/Default"],
          flexShrink: 0,
        }}
      >
        Open
      </span>
    </button>
  );
};
